import { Sparkles, LogOut, History, PenLine, Crown } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useBilling } from "../context/BillingContext";
import { Link, useNavigate } from "react-router-dom";
import Logo from "./Logo";

export default function Header() {
  const { user, logout } = useAuth();
  const { entitlements } = useBilling();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-[#0F0F14]/70 backdrop-blur-xl border-b border-white/[0.06]">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="logo-home-link">
          <Logo size="md" />
        </Link>
        <nav className="flex items-center gap-2 md:gap-3">
          {entitlements?.is_premium ? (
            <span
              className="hidden sm:inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.25em] text-[#FF4D8D] border border-[#FF4D8D]/40 bg-[#FF4D8D]/10 px-3 py-1.5 rounded-full"
              data-testid="header-premium-badge"
            >
              <Crown className="w-3 h-3" /> Premium
            </span>
          ) : (
            <Link
              to="/pricing"
              className="hidden sm:inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.25em] text-white bg-gradient-to-r from-[#FF4D8D] to-[#7B61FF] px-3 py-1.5 rounded-full active:scale-95 transition"
              data-testid="header-pricing-link"
            >
              <Crown className="w-3 h-3" /> Premium
            </Link>
          )}
          {user ? (
            <>
              <Link
                to="/questions"
                className="flex items-center gap-2 text-sm font-semibold text-[#C9C7D9] hover:text-white px-4 py-2 rounded-full transition"
                data-testid="nav-questions-link"
              >
                <PenLine className="w-4 h-4" />
                <span className="hidden sm:inline">Questions</span>
              </Link>
              <Link
                to="/history"
                className="flex items-center gap-2 text-sm font-semibold text-[#C9C7D9] hover:text-white px-4 py-2 rounded-full transition"
                data-testid="nav-history-link"
              >
                <History className="w-4 h-4" />
                <span className="hidden sm:inline">History</span>
              </Link>
              <span className="hidden md:inline text-sm text-[#C9C7D9] font-medium">
                Hi, <span className="text-white font-semibold">{user.name}</span>
              </span>
              <button
                onClick={() => {
                  logout();
                  nav("/");
                }}
                className="flex items-center gap-2 text-sm font-semibold text-white bg-white/5 hover:bg-white/10 px-4 py-2 rounded-full transition border border-white/10"
                data-testid="nav-logout-button"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">Logout</span>
              </button>
            </>
          ) : (
            <Link
              to="/login"
              className="text-sm font-semibold text-white btn-gradient px-5 py-2.5 rounded-full transition"
              data-testid="nav-login-link"
            >
              Sign in
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
